import axios from "../../../axios"

export default {
  async upload(file, bannerDirection = null) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('banner_direction', (bannerDirection ? bannerDirection : 'none'))
    return await axios.post('file/upload', formData);
  },
  async delete(filename) {
    return await axios.delete(`file/delete/${filename}`);
  }
}